export default __webpack_public_path__ + "static/BulldogJob-logo.34bbbab5-f7578e44d401b55f759dc8e44c08a4c6.svg";